const list = state => state.list;
const current = state => state.current;

export default {
  list,
  current,
};
